<template>
  <div class="row">
    <div id="police-logo" class="col-4 col-md-2 police-logo">
      <img src="@/assets/policeLogoHead.png" alt="img" class="police-logo-img"/>
    </div>
  </div>
  <h1 class="mt-5">ثبت نام اولیه سامانه پلیس امنیت</h1>
</template>

<script>
export default {
  name: "headWithLogo"
}
</script>

<style scoped>

</style>